export const LANDING = {
    // Navbar
    navLogo: "nav-logo",
    navLinkFeatures: "nav-link-features",
    navLinkPricing: "nav-link-pricing",
    navLinkFaq: "nav-link-faq",
    navLinkAbout: "nav-link-about",
    navLinkContact: "nav-link-contact",
    navRequestDemoBtn: "nav-request-demo-button",
    navMobileToggle: "nav-mobile-toggle",

    // Hero
    heroRequestDemoBtn: "hero-request-demo-button",
    heroLearnMoreBtn: "hero-learn-more-button",

    // Features
    featureSafety: "feature-card-safety",
    featureAssurance: "feature-card-assurance",
    featureAudit: "feature-card-audit",
    featureActionTracker: "feature-card-action-tracker",
    featureOffline: "feature-card-offline",
    featureBenchmarking: "feature-card-benchmarking",
    featureWorkflows: "feature-card-workflows",

    // Pricing
    pricingStarterBtn: "pricing-starter-button",
    pricingProfessionalBtn: "pricing-professional-button",
    pricingEnterpriseBtn: "pricing-enterprise-button",

    // FAQ
    faqItem: (i) => `faq-item-${i}`,

    // Contact
    contactName: "contact-name-input",
    contactEmail: "contact-email-input",
    contactCompany: "contact-company-input",
    contactRole: "contact-role-input",
    contactMessage: "contact-message-input",
    contactSubmit: "contact-submit-button",
    contactEmailLink: "contact-email-link",

    // Footer
    footerBackToTop: "footer-back-to-top",
};
